function validateInput(inputValue) {
  if (Number.isFinite(parseFloat(inputValue))) {
    return true;
  } else {
    return false;
  }
}

export default validateInput;
